import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <> 
      {/* NOTA: Non serve più <div className="main-container"> qui attorno,
         perché è già gestito da App.js. Usiamo i Fragment (<>...</>) 
      */}

      {/* HERO */}
      <header className="hero">
        {/* Navbar rimossa da qui perché è fissa in App.js */}
        
        <div className="hero-content">
          <h1>Sviluppo Web & Mobile</h1>
          <p className="subtitle">
            Dal sito vetrina all'App nativa complessa.<br />
            Codice pulito, tempi certi, focus sul business.
          </p>
          <div className="cta-group">
            <Link to="/contact" className="btn-secondary">Chiedi un preventivo</Link>
          </div>
        </div>
      </header>

      {/* SERVIZI */}
      <section className="services-split">
        <div className="service-card wp-side">
          <h3>Business Rapido</h3>
          <p className="tech-label">WordPress • WooCommerce</p>
          <ul>
            <li>✅ Siti Vetrina pronti in tempi brevi</li>
            <li>✅ E-commerce ottimizzati per vendere</li>
            <li>✅ Gestione autonoma dei contenuti</li>
          </ul>
        </div>

        <div className="service-card dev-side">
          <h3>Sviluppo Custom</h3>
          <p className="tech-label">React • Native • Custom WP</p>
          <ul>
            <li>🚀 Web App ad alte prestazioni</li>
            <li>📱 App Native (iOS/Android)</li>
            <li>⚙️ Funzionalità su misura complesse</li>
          </ul>
        </div>
      </section>

      {/* TRUST SECTION */}
      <section className="why-me">
        <div className="trust-content">
          <span className="tech-label">Il vantaggio del Freelance</span>
          <h2>Il tuo budget, 100% sul codice.</h2>
          <p className="trust-description">
            Scegliere me significa investire sulla <strong>qualità del prodotto</strong>, eliminando i ricarichi
            di gestione delle agenzie. Avrai un unico interlocutore tecnico per una comprensione immediata
            e tempi di esecuzione dimezzati.
          </p>

          <div className="benefits-grid">
            <div className="benefit-item">
              <span className="benefit-icon">💰</span>
              <h4>Budget Ottimizzato</h4>
              <p>Ogni euro finisce direttamente nello sviluppo del tuo progetto.</p>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">⚡</span>
              <h4>Velocità</h4>
              <p>Niente "telefono senza fili": dal preventivo al codice in un passo.</p>
            </div>
            <div className="benefit-item">
              <span className="benefit-icon">🛠️</span>
              <h4>Sarto Digitale</h4>
              <p>Soluzioni custom cucite sulle tue reali esigenze di business.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer rimosso da qui */}
    </>
  );
}

export default Home;